import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import ClassRoom from '../components/classroom';
import { SocketProvider } from '../components/classroom/context/SocketContext';
import { AppPage } from '../layouts/types';
import store, { AppDispatch, RootState } from '../store';
import { fetchThemeColor, updateLiveStreamSettings } from '../store/reducers/livestreamSettings';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'react';
import { User } from 'models/User';

const LiveSession: AppPage = () => {
  const [searchParams] = useSearchParams();
  let roomID = searchParams.get("sessionId");
  let programId = searchParams.get("programId");
  const user: any = useSelector((state: RootState) => state.auth.user as User);
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    if (roomID) {
      store.dispatch(updateLiveStreamSettings({ roomId: roomID }));
    }
  }, [roomID]);

  useEffect(() => {
    dispatch(fetchThemeColor({ programId: Number(programId), userId: user.id }));
  }, [programId]);

  return (
    <ClassRoom></ClassRoom>
    // <SocketProvider>
    //   <ClassRoom></ClassRoom>
    // </SocketProvider>
  );

};

export default LiveSession;